import { useCallback } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3002/api";

// Shared authenticated fetch for every admin tab — attaches the Firebase ID token,
// routes a 403 up to the shell (which shows the "not authorized" gate), and unwraps
// the { statusCode, data, error } envelope every backend route already returns.
export function useAdminApi(user, onForbidden) {
  return useCallback(async (path, options = {}) => {
    const idToken = await user.getIdToken();
    const response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${idToken}`,
      },
    });
    if (response.status === 403) {
      onForbidden();
      throw new Error("Forbidden");
    }
    const body = await response.json();
    if (!response.ok) throw new Error(body.error || "Request failed");
    return body.data;
  }, [user, onForbidden]);
}
